import { render, staticRenderFns } from "./realtimeBehaviours.vue?vue&type=template&id=ce46a5f4&"
import script from "./realtimeBehaviours.vue?vue&type=script&lang=js&"
export * from "./realtimeBehaviours.vue?vue&type=script&lang=js&"
import style0 from "./realtimeBehaviours.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports